import { Helmet } from 'react-helmet-async';
import { MdOutlineShoppingCart } from 'react-icons/md';
import BackButton from '../BackButton';

export default function ProductNotFound() {
  return (
    <>
      <Helmet>
        <title>Produit introuvable - Stop Pièces Auto</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="w-full content sm:mt-[24px]">
        {/* Product images and Details  */}
        <div
          className={
            'w-full grid lg:grid-cols-2 gap-[24px] xl:gap-[48px] mb-[100px]'
          }
        >
          {/* Left Side  */}
          <div className="w-full space-y-[12px] md:space-y-[24px] bg-slate-200 h-[200px] md:h-[300px] lg:h-[500px] rounded"></div>
          {/* Right Side  */}
          <div className="w-full">
            <div className="flex items-start  gap-[10px] sm:gap-0">
              <h1 className="font-clash font-[600] text-[24px] sm:text-[36px] leading-[1.1] sm:leading-[32px] opacity-50">
                Produit introuvable
              </h1>
            </div>

            <div className="flex flex-wrap my-[20px] gap-[10px] sm:gap-[12px]">
              <button className="center px-[18px] border-[3px] border-red-500 text-red-500 uppercase sm:text-[18px] font-[700] py-[8px] sm:py-[12px] rounded-[8px] cursor-default">
                INTROUVABLE
              </button>
            </div>

            <div className="mt-6 space-y-3">
              {/* Boutons d'action principaux */}
              <div className="flex gap-2">
                <button
                  className="flex-1 bg-orange text-white h-14 rounded-xl font-medium flex items-center justify-center gap-2 hover:bg-orange/90 transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-orange"
                  disabled
                >
                  <MdOutlineShoppingCart className="w-6 h-6" />
                  Ajouter au panier
                </button>
                <button
                  className="h-14 w-14 rounded-xl bg-slate-100 hover:bg-slate-200 transition-all flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-slate-100"
                  disabled
                >
                  <img
                    src="/pictos/unliked.png"
                    alt=""
                    className="max-w-[20px] sm:max-w-[21px] max-h-[18.6px] opacity-[.6]"
                  />
                </button>
              </div>
            </div>

            <div className="flex flex-col gap-2 mt-[20px] mb-[10px]">
              <p className="text-dark transition font-bold">
                Ce produit a été vendu ou n'est plus accessible.
              </p>
              <p className="text-dark transition">
                Découvrez nos autres produits.
              </p>
            </div>

            <BackButton />
          </div>
        </div>
      </div>
    </>
  );
}
